var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isRfpTypePublicOffer } from '@/utils/resources/rfp/rfpType';
/**
 * 型判定 公募かどうか
 * @param rfpType 案件種別
 * @param offerFormValues OfferForm 値
 * @returns
 */
export const getIsPublic = (rfpType, values) => isRfpTypePublicOffer(rfpType);
const formatAdditionalFiles = (AdditionalFiles) => (AdditionalFiles || []).map((AdditionalFile) => ({
    id: AdditionalFile.id === null ? undefined : AdditionalFile.id,
    new_file_id: AdditionalFile.new_file_id === null
        ? undefined
        : AdditionalFile.new_file_id,
}));
/**
 * offer をリクエスト用の値に変換（公募）
 * @param offerValues
 * @returns
 */
export const getPublicOfferValues = (offerValues) => (Object.assign(Object.assign({}, offerValues), { additional_files: formatAdditionalFiles(offerValues.additional_files), new_file_id: offerValues.file.new_file_id === null
        ? undefined
        : offerValues.file.new_file_id, period: typeof offerValues.period === 'string'
        ? parseInt(offerValues.period, 10) || null
        : offerValues.period, price: typeof offerValues.price === 'string'
        ? parseInt(offerValues.price, 10) || null
        : offerValues.price }));
/**
 * 提案入力 下書き保存の値取得（公募）
 * @param offerFormValues
 * @param formValues
 * @returns
 */
export const getPublicOfferDraftValues = (offerFormValues, formValues) => ({
    assign: offerFormValues.assign,
    offer: getPublicOfferValues(offerFormValues.offer),
    payment: formValues.payment,
    rfp_offer_members: offerFormValues.rfp_offer_members,
});
/**
 * offer をリクエスト用の値に変換（公募）
 * @param offerValues
 * @returns
 */
export const getDirectOfferValues = (offerValues) => (Object.assign(Object.assign({}, offerValues), { additional_files: formatAdditionalFiles(offerValues.additional_files), max_period: typeof offerValues.max_period === 'string'
        ? parseInt(offerValues.max_period, 10) || null
        : offerValues.max_period, max_price: typeof offerValues.max_price === 'string'
        ? parseInt(offerValues.max_price, 10) || null
        : offerValues.max_price, period: typeof offerValues.period === 'string'
        ? parseInt(offerValues.period, 10) || null
        : offerValues.period, price: typeof offerValues.price === 'string'
        ? parseInt(offerValues.price, 10) || null
        : offerValues.price }));
/**
 * 提案入力 下書き保存の値取得（RFI/業務委託）
 * @param offerFormValues
 * @param formValues
 * @returns
 */
export const getDirectOfferDraftValues = (offerFormValues, formValues) => ({
    assign: offerFormValues.assign,
    offer: getDirectOfferValues(offerFormValues.offer),
    payment: formValues.payment,
    rfp_offer_members: offerFormValues.rfp_offer_members,
});
/**
 * 提案入力支払い 下書き保存の値取得（RFI/業務委託）
 * @param offerFormValues
 * @param formValues
 * @returns
 */
export const getDirectPaymentDraftValues = (paymentFormValues, formValues) => ({
    assign: formValues.assign,
    offer: getDirectOfferValues(formValues.offer),
    payment: paymentFormValues.payment,
    rfp_offer_members: formValues.rfp_offer_members,
});
/**
 * 提案入力支払い 下書き保存の値取得（公募）
 * @param offerFormValues
 * @param formValues
 * @returns
 */
export const getPublicPaymentDraftValues = (paymentFormValues, formValues) => ({
    assign: formValues.assign,
    offer: getPublicOfferValues(formValues.offer),
    payment: paymentFormValues.payment,
    rfp_offer_members: formValues.rfp_offer_members,
});
/**
 * 提案入力 保存の値取得（RFI/業務委託）
 * @param formValues
 * @returns
 */
export const getDirectSaveValues = (formValues) => ({
    assign: formValues.assign,
    offer: Object.assign(Object.assign({}, formValues.offer), { additional_files: formatAdditionalFiles(formValues.offer.additional_files) }),
    payment: formValues.payment,
    rfp_offer_members: formValues.rfp_offer_members,
});
/**
 * 提案入力 保存の値取得（公募）
 * @param formValues
 * @returns
 */
export const getPublicSaveValues = (formValues) => ({
    assign: formValues.assign,
    offer: Object.assign(Object.assign({}, formValues.offer), { additional_files: formatAdditionalFiles(formValues.offer.additional_files), new_file_id: formValues.offer.file.new_file_id === null
            ? undefined
            : formValues.offer.file.new_file_id }),
    payment: formValues.payment,
    rfp_offer_members: formValues.rfp_offer_members,
});
/**
 * submit のラップ処理（提案入力）
 * @description submit 後に下書き保存フラグを戻し、不要なエラーを表示しないための処理
 */
export const parentOnSubmitOfOffer = (form, handleSubmit) => (event) => __awaiter(void 0, void 0, void 0, function* () {
    const currentTouched = form.getState().touched;
    const isDraft = form.getState().values.is_draft;
    try {
        yield (handleSubmit === null || handleSubmit === void 0 ? void 0 : handleSubmit(event));
        // submit 後に 下書き判定フラグを false に戻す
        form.change('is_draft', false);
    }
    finally {
        // 下書きの場合
        if (isDraft) {
            Object.keys(currentTouched || {}).forEach((touchKey) => {
                const hasKey = (key) => (currentTouched === null || currentTouched === void 0 ? void 0 : currentTouched[key]) !== undefined;
                if (hasKey(touchKey) &&
                    !(currentTouched === null || currentTouched === void 0 ? void 0 : currentTouched[touchKey]) &&
                    !['rfp_offer_members'].includes(touchKey)) {
                    form.resetFieldState(touchKey);
                }
            });
        }
    }
});
/**
 * submit のラップ処理（提案入力 支払い）
 * @description submit 後に下書き保存フラグを戻し、不要なエラーを表示しないための処理
 */
export const parentOnSubmitOfPayment = (form, handleSubmit) => (event) => __awaiter(void 0, void 0, void 0, function* () {
    const currentTouched = form.getState().touched;
    const isDraft = form.getState().values.is_draft;
    try {
        yield handleSubmit(event);
        // submit 後に 下書き判定フラグを false に戻す
        form.change('is_draft', false);
    }
    finally {
        // 下書きの場合
        if (isDraft) {
            Object.keys(currentTouched || {}).forEach((touchKey) => {
                const hasKey = (key) => (currentTouched === null || currentTouched === void 0 ? void 0 : currentTouched[key]) !== undefined;
                if (hasKey(touchKey) && !(currentTouched === null || currentTouched === void 0 ? void 0 : currentTouched[touchKey])) {
                    form.resetFieldState(touchKey);
                }
            });
        }
    }
});
